import React, { Fragment, useState } from "react";
import { Field } from 'formik';
import TimeField from 'react-simple-timefield';
import { Container } from "styles/components/TimePickerInput";
import { InputContainer } from "styles/components/AnimatedInput";
import { useEffect } from "react";

const TimePickerInput = (props) => {
    let setTimeVal = "00:00"

    if (props?.endTime) {
        setTimeVal = props?.endTime
    }
    if (props?.editResponse) {
        // props?.name ==="appt" &&
        // if( props?.editResponse?.data.loadDetails.deliveryFromtime){
        //     setTimeVal =  props?.editResponse?.data?.loadDetails.deliveryFromtime
        // }

        if (props?.name === "deliveryWindowBegin")
            setTimeVal = props?.editResponse?.data?.deliveryFromTime

        if (props?.name === "deliveryWindowEnd")
            setTimeVal = props?.editResponse?.data?.deliveryToTime
    } else {
        if (props?.name === "deliveryWindowEnd") {
            setTimeVal = "17:00"
        }
    }

    const [selectedTime, handleTimeChange] = useState();

    useEffect(() => {
        if(props.selectedTimeValue) handleTimeChange(props.selectedTimeValue)
    }, [props.selectedTimeValue])
    
    const changeHandler = (name, setFieldValue, time) => {
        let setTime = time.target.value
        handleTimeChange(setTime)
        setFieldValue(name, setTime);
        props?.onChangeHandler(setTime)
    }

    return (
        <div>
            <Field name={props?.name}>
                {({ field, form, meta }) => {
                    return (
                        <InputContainer className={props.className}>
                            <div className="input-container">
                                <Fragment>
                                    <Container>
                                        <div className='custom-date-piker'>
                                            <div
                                                className={`app-input-text ${meta.touched && meta.error ? 'error' : ''
                                                    }`}
                                            >
                                                <TimeField
                                                    disabled={props?.disabled}
                                                    className='s-input -time'
                                                    name={props?.name}
                                                    value={selectedTime ? selectedTime : setTimeVal}
                                                    onChange={(time) => {
                                                        changeHandler(props?.name, form.setFieldValue, time)
                                                    }} />
                                            </div>

                                        </div>
                                    </Container>
                                    {meta.error && <p name={props?.name} className="error-message">{meta.error}</p>}
                                </Fragment>
                                <label className={field.value && 'filled'} htmlFor={props?.name}>
                                    {props?.placeholder}
                                </label>
                            </div>
                        </InputContainer>
                    );
                }}
            </Field>

        </div>
    );
};
export default TimePickerInput;
